import { useState, useEffect, useRef } from 'react'
import Catalog from './components/Catalog'
import AdminPanel from './components/AdminPanel'
import Ticker from './components/Ticker'
import Footer from './components/Footer'
import Mayoreo from './components/Mayoreo'
import { HiArrowUp } from "react-icons/hi";
import {
  getProductos,
  addProducto,
  updateProducto,
  deleteProducto,
  reorderProductos,
  onAuthChange
} from './firebase'
import './App.css'
import { WA_NUMBER } from './constants'

export default function App() {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [adminOpen, setAdminOpen] = useState(false)
  const [adminAuth, setAdminAuth] = useState(false)
  const [showFloat, setShowFloat] = useState(true)
  const lastScrollY = useRef(0)
  const [adminClickCount, setAdminClickCount] = useState(0)
  const [showAdminBtn, setShowAdminBtn] = useState(false)
  const adminClickTimer = useRef(null)

  useEffect(() => {
    fetchProducts()
  }, [])

  useEffect(() => {
    const unsub = onAuthChange((user) => {
      if (!user) {
        setAdminAuth(false)
        setAdminOpen(false)
      } else {
        setAdminAuth(true)
      }
    })
    return () => unsub()
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 768) {
        setShowFloat(true)
        return
      }
      const currentY = window.scrollY
      if (currentY < lastScrollY.current) {
        setShowFloat(true)
      } else {
        setShowFloat(false)
      }
      lastScrollY.current = currentY
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleSecretClick = () => {
    setAdminClickCount(prev => {
      const next = prev + 1
      // Reinicia el contador si pasan 2 segundos sin click
      clearTimeout(adminClickTimer.current)
      adminClickTimer.current = setTimeout(() => {
        setAdminClickCount(0)
      }, 2000)

      if (next >= 5) {
        setShowAdminBtn(true)
        setAdminClickCount(0)
      }
      return next
    })
  }

  const fetchProducts = async () => {
    try {
      setLoading(true)
      const data = await getProductos()
      setProducts(data)
    } catch (err) {
      console.error('Error cargando productos:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleAdd = async (product) => {
    try {
      const id = await addProducto(product)
      setProducts(prev => [...prev, { ...product, id }])
    } catch (err) {
      console.error('Error agregando producto:', err)
    }
  }

  const handleUpdate = async (id, data) => {
    try {
      await updateProducto(id, data)
      setProducts(prev => prev.map(p => p.id === id ? { ...p, ...data } : p))
    } catch (err) {
      console.error('Error actualizando producto:', err)
    }
  }

  const handleDelete = async (id) => {
    try {
      await deleteProducto(id)
      setProducts(prev => prev.filter(p => p.id !== id))
    } catch (err) {
      console.error('Error eliminando producto:', err)
    }
  }

  const handleReorder = async (from, to) => {
    const arr = [...products]
    const [moved] = arr.splice(from, 1)
    arr.splice(to, 0, moved)
    setProducts(arr)
    try {
      await reorderProductos(arr)
    } catch (err) {
      console.error('Error reordenando:', err)
    }
  }

  const goToCatalogo = (e) => {
    e.preventDefault();

    document.getElementById('catalogo')?.scrollIntoView({
      behavior: 'smooth'
    });
  };

  const goToMayoreo = (e) => {
    e.preventDefault();

    document.getElementById('mayoreo')?.scrollIntoView({
      behavior: 'smooth'
    });
  };


  return (
    <div className="app">
      <header className="header">
        <p className="location">TORREÓN · GÓMEZ PALACIO · LERDO</p>
        <div className="header-cta">
          <img src="/images/lumi logo.png" alt="Lumi Crafts Logo" className="logo" width="440" decoding="async" data-nimg="1"/>
        </div>
        <br />
        <h1>Detalles Personalizados</h1>
        <p className="subtitle">Personalizamos vasos, cajas y regalos para cualquier ocasión</p>
        <div className="header-cta">
          <a
            className="btn-dark"
            onClick={goToCatalogo}
          >
            Ver catálogo
          </a>
          <a
            className="btn-outline"
            onClick={goToMayoreo}
          >
            Precios de mayoreo
          </a>
        </div>
      </header>

      <Ticker />

      <section id="mayoreo" className="mayoreo-section">
        <div className="section-header">
          <p className="tag">[ Mayoreo ]</p>
          <h2>Entre más vasos,<br />
          <span className="accent">más barato</span></h2>
        </div>

        <Mayoreo waNumber={WA_NUMBER} />
      </section>

      <section id="catalogo" className="catalog-section">
        <div className="section-header">
          <p className="tag">[ Disponible hoy ]</p>
          <h2>El <span className="accent">Catálogo</span></h2>
        </div>
        {loading ? (
          <div className="catalog-loading">
            <div className="spinner" />
            <p>Cargando catálogo...</p>
          </div>
        ) : (
          <Catalog products={products} waNumber={WA_NUMBER} />
        )}
      </section>

      <div className={`float-group ${showFloat ? 'visible' : 'hidden'}`}>
        <button
          className="scroll-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Volver arriba"
        >
          <HiArrowUp size={20} />
        </button>
        <a
          className="wa-float"
          href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hola! Quisiera cotizar un pedido.')}`}
          target="_blank"
          rel="noreferrer"
          aria-label="Escríbenos"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.555 4.116 1.529 5.843L.057 23.982l6.305-1.654A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.891 0-3.667-.5-5.2-1.375l-.374-.22-3.862 1.013 1.031-3.764-.243-.386A9.937 9.937 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
          </svg>
          <span className="wa-label">Escríbenos</span>
        </a>
      </div>

      {showAdminBtn && (
        <button
          className="admin-trigger"
          onClick={() => {
            setAdminOpen(true)
            setShowAdminBtn(false)
          }}
          aria-label="Administrar catálogo"
          title="Administrar catálogo"
        >
          ⚙
        </button>
      )}

      {adminOpen && (
        <AdminPanel
          products={products}
          auth={adminAuth}
          onAuth={() => setAdminAuth(true)}
          onClose={() => setAdminOpen(false)}
          onAdd={handleAdd}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
          onReorder={handleReorder}
        />
      )}

      <Ticker />

      <Footer />

      <footer className="footer">
        <p onClick={handleSecretClick} style={{ userSelect: 'none' }}>
          © 2026 Lumi Crafts. All rights reserved.
        </p>
      </footer>
    </div>
  )
}
